import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CheckmarkSVG = function CheckmarkSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.41 6.57a2 2 0 00-2.83 0L11.36 21.32l-5.95-5.77a2 2 0 00-2.83 0 1.9 1.9 0 000 2.74L10 25.43a2 2 0 002.83 0L29.41 9.31a1.9 1.9 0 000-2.74z"
  }));
};
CheckmarkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CheckmarkSVG);